/**
 * Centralized datetime utility functions using vanilla JavaScript.
 * This module replaces moment.js functionality with native Date APIs.
 * All datetime operations should use these utilities for consistency.
 */

/**
 * Get the current year
 * Replaces: moment().year()
 * @returns {number} Current year (e.g., 2025)
 */
export const getCurrentYear = () => {
    return new Date().getFullYear()
}
